import React from "react";
import { Checkbox, Input, Select } from "semantic-ui-react";

function ReportPeriodSelector({ periods, selectedPeriod, filters, onChange }) {
    const customDates = filters.customDates === true;
    const periodOptions = periods.map((period) => ({
        key: period.key,
        text: period.label,
        value: period.key,
    }));

    const update = (changes) => {
        onChange({
            ...filters,
            ...changes,
        });
    };

    return (
        <div className='row mt-3 mb-3'>
            <div className='col-sm-12 col-md-4 mb-2'>
                <label className='with-input'>Period</label>
                <Select
                    fluid
                    disabled={customDates}
                    options={periodOptions}
                    value={filters.periodKey || selectedPeriod?.key}
                    onChange={(event, selection) =>
                        update({ periodKey: selection.value })
                    }
                />
            </div>
            <div className='col-sm-12 col-md-3 mb-2'>
                <label className='with-input'>Custom range</label>
                <div>
                    <Checkbox
                        toggle
                        label={customDates ? "On" : "Off"}
                        checked={customDates}
                        onChange={() =>
                            update({
                                customDates: !customDates,
                                startDate: customDates ? undefined : filters.startDate,
                                endDate: customDates ? undefined : filters.endDate,
                            })
                        }
                    />
                </div>
            </div>
            {customDates && (
                <>
                    <div className='col-sm-12 col-md-2 mb-2'>
                        <label className='with-input'>Start date</label>
                        <Input
                            fluid
                            type='date'
                            value={
                                filters.startDate ||
                                selectedPeriod?.startDate ||
                                ""
                            }
                            onChange={({ target }) =>
                                update({ startDate: target.value })
                            }
                        />
                    </div>
                    <div className='col-sm-12 col-md-2 mb-2'>
                        <label className='with-input'>End date</label>
                        <Input
                            fluid
                            type='date'
                            value={
                                filters.endDate ||
                                selectedPeriod?.endDate ||
                                ""
                            }
                            onChange={({ target }) =>
                                update({ endDate: target.value })
                            }
                        />
                    </div>
                </>
            )}
        </div>
    );
}

export default ReportPeriodSelector;
